import { rtkApi } from "../../../shared/api/rtkApi";
import {
    CareerBackInterfacesDTOBlogBlogDto,
    CareerBackInterfacesDTOBlogBlogPreviewDto,
} from "../../../shared/ApiContract/data-contracts";
import { removeNullKeys } from "../../../shared/lib/helpers";

const blogApi = rtkApi.injectEndpoints({
    endpoints: (build) => ({
        getPosts: build.query<CareerBackInterfacesDTOBlogBlogPreviewDto[], { skip?: number; take?: number }>({
            query: (params) => ({
                url: `blog/news?${new URLSearchParams(removeNullKeys(params ?? {}))}`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOBlogBlogPreviewDto[]) => response,
        }),
        getPostImage: build.query<string, string>({
            query: (previewImageId) => ({
                url: `blog/image/${previewImageId}`,
                responseHandler: async (response) => URL.createObjectURL(await response.blob()),
                cache: "no-cache",
            }),
            transformResponse: (response: string) => response,
        }),
        getPost: build.query<CareerBackInterfacesDTOBlogBlogDto, string>({
            query: (postId) => ({
                url: `blog/${postId}`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOBlogBlogDto) => response,
        }),
    }),
});

export const { useGetPostsQuery, useGetPostImageQuery, useGetPostQuery } = blogApi;
